"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IComponentAs.js.map